import React from "react";

import { Skeleton, Table, TableBody, TableCell, TableProps, TableRow } from "@mui/material";

interface TableRowsLoaderProps {
  rowsNum: number;
  tableProps?: TableProps;
}

export const TableSkeletonLoader: React.FC<TableRowsLoaderProps> = ({ rowsNum, tableProps }) => {
  return (
    <Table {...tableProps}>
      <TableBody>
        {[...Array(rowsNum)].map((_, index) => (
          <TableRow key={index}>
            <TableCell component="th" scope="row">
              <Skeleton animation="wave" variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
            <TableCell>
              <Skeleton animation="wave" variant="text" />
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};
